var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showDetails)?_c('div',{staticClass:"body-1 text--details--color"},[_c('px-oferta-imposto-nao-incluso',{attrs:{"oferta":_vm.oferta,"variacao":_vm.variacao}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }